/* ==========================================================================
   Cart minimum order guard.

   Event Set Up & Styling packages carry a $1,500 floor. Rather than hard-code
   that here or depend on product tags that do not exist yet, each package
   writes its own floor onto the cart line as the hidden property
   _minimum_order. This reads the highest floor in the cart and holds checkout
   until the subtotal clears it.

   This is a front-end guard on the cart page and drawer. It stops the ordinary
   route to checkout; it is not a server-side rule, so a determined customer
   can still reach /checkout directly. Closing that properly needs a Shopify
   Cart & Checkout Validation function, which is a separate app deploy.
   ========================================================================== */
(function () {
  'use strict';

  var MESSAGE_ID = 'cart-minimum-notice';

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  /* Every control that would take someone to checkout. Dawn renders the cart
     page button, the drawer button, and the dynamic wallet buttons separately. */
  function checkoutControls() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[name="checkout"], .cart__dynamic-checkout-buttons, [data-shopify="dynamic-checkout-cart"]')
    );
  }

  function notice(host) {
    var el = document.getElementById(MESSAGE_ID);
    if (el) return el;

    el = document.createElement('p');
    el.id = MESSAGE_ID;
    el.className = 'cart-minimum-notice';
    el.setAttribute('role', 'status');
    host.parentNode.insertBefore(el, host);
    return el;
  }

  function clear() {
    var el = document.getElementById(MESSAGE_ID);
    if (el) el.remove();
    checkoutControls().forEach(function (c) {
      c.classList.remove('is-blocked');
      if ('disabled' in c) c.disabled = false;
      c.removeAttribute('aria-disabled');
    });
  }

  function block(shortfall, floor) {
    var controls = checkoutControls();
    if (!controls.length) return;

    controls.forEach(function (c) {
      c.classList.add('is-blocked');
      if ('disabled' in c) c.disabled = true;
      c.setAttribute('aria-disabled', 'true');
    });

    notice(controls[0]).textContent =
      'Minimum order for Event Set Up & Styling packages is ' + money(floor) +
      '. You are ' + money(shortfall) + ' short — please adjust your guest numbers or package selection.';
  }

  function check() {
    /* Most pages have no route to checkout, so do not fetch the cart on them. */
    if (!checkoutControls().length) return Promise.resolve();

    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* The highest floor in the cart wins: a $1,500 grazing table sitting
           beside a $300 drop off order still has to clear $1,500. */
        var floor = 0;
        (cart.items || []).forEach(function (item) {
          var raw = item.properties && item.properties._minimum_order;
          var n = parseInt(raw, 10);
          if (n > floor) floor = n;
        });

        if (!floor) { clear(); return; }

        var floorCents = floor * 100;
        if (cart.total_price >= floorCents) clear();
        else block(floorCents - cart.total_price, floorCents);
      })
      .catch(function () { /* never let a failed check block a working cart */ clear(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }

  /* Dawn re-renders the cart over fetch, so re-check whenever it does. */
  document.addEventListener('cart:refresh', check);
  document.addEventListener('cart:updated', check);
  document.addEventListener('shopify:section:load', check);

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var href = typeof url === 'string' ? url : (url && url.url) || '';
    var out = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(href)) out.then(function () { setTimeout(check, 60); });
    return out;
  };
})();
